(function () {
  'use strict';

  function getHeroVideo(node) {
    if (!node) return null;
    if (node.tagName === 'VIDEO') return node;
    return node.querySelector('video');
  }

  function prepareHeroVideo(video) {
    video.autoplay = true;
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('autoplay', 'autoplay');
    video.setAttribute('muted', 'muted');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    video.setAttribute('preload', 'auto');

    if (!video.dataset.sstVideoLoadStarted && video.readyState === 0 && typeof video.load === 'function') {
      video.dataset.sstVideoLoadStarted = 'true';
      video.load();
    }
  }

  function playHeroVideo(node) {
    var video = getHeroVideo(node);
    if (!video || typeof video.play !== 'function') return;

    prepareHeroVideo(video);

    var playAttempt = video.play();
    if (playAttempt && typeof playAttempt.catch === 'function') {
      playAttempt.catch(function () {});
    }
  }

  function initHeroVideos(root) {
    root.querySelectorAll('.sst-hero__bg-video').forEach(function (node) {
      var video = getHeroVideo(node);
      if (!video) return;
      if (video.dataset.sstVideoReady) return;
      video.dataset.sstVideoReady = 'true';

      playHeroVideo(video);
      video.addEventListener('loadeddata', function () {
        playHeroVideo(video);
      }, { once: true });
      video.addEventListener('canplay', function () {
        playHeroVideo(video);
      }, { once: true });
    });
  }

  initHeroVideos(document);

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.sst-hero__bg-video').forEach(playHeroVideo);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      document.querySelectorAll('.sst-hero__bg-video').forEach(playHeroVideo);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initHeroVideos(event.target);
  });
})();
